module.exports = __webpack_public_path__ + "img/storyboard_lite_menuboards.b54a2437.webp";